import { Stack } from "@mui/material";
import React, { ReactNode } from "react";
import Header from "../components/Header/Header";

type DefaultLayoutWrapperProps = {
    children: ReactNode;
}

const DefaultLayoutWrapper = ({ children }: DefaultLayoutWrapperProps) => {
    return (
        <Stack
            sx={{
                height: '100dvh',
                width: '100%',
                maxWidth: '100vw',
                display: 'grid',
                gridTemplateRows: 'auto 1fr',
                overflow: 'hidden'
            }}
        >
            <Header />
            <Stack
                component="main"
                sx={{
                    minHeight: 0,
                }}
            >
                {children}
            </Stack>
        </Stack>
    );
}

export default DefaultLayoutWrapper